import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { api } from "../../api/client.ts";
import { keys } from "../../api/queryKeys.ts";
import type { OptionsSpec } from "../filters/specs.ts";

/** The `?collection_id=` param: one collection's rows. */
export const COLLECTION_PARAM = "collection_id";

/**
 * The "Collection" filter: the tenant's live collections, plus the picked one
 * even when archived (a link's), so its pill names it.
 */
export function useCollectionFilter(tenantId: string | null, picked: string, group?: string): OptionsSpec {
  const { data: lists, isLoading } = useQuery({
    queryKey: keys.prospectList.list(tenantId ?? ""),
    queryFn: () => api.getProspectLists(tenantId!),
    enabled: !!tenantId,
    staleTime: 5 * 60_000,
  });
  return useMemo<OptionsSpec>(
    () => ({
      kind: "options",
      key: "list",
      label: "Collection",
      param: COLLECTION_PARAM,
      group,
      multiple: false,
      noneLabel: "Any collection",
      loading: isLoading,
      options: (lists ?? [])
        .filter((l) => !l.archived || l.id === picked)
        .map((l) => ({ value: l.id, label: l.name })),
      searchPlaceholder: "Search collections",
    }),
    [lists, isLoading, picked, group],
  );
}
